import { z } from 'zod';
import { ROLES } from '../enums.js';
// ============================================================================
// H-04 — API keys para integración externa.
// La key actúa con un ROL (acts-as): reusa el RBAC existente. Las acciones se
// atribuyen al usuario dueño de la key. La key en claro se muestra UNA sola vez.
// ============================================================================
export const apiKeyCrearSchema = z.object({
    nombre: z.string().min(3).max(100),
    rol: z.enum(ROLES),
});
export const apiKeyPublicSchema = z.object({
    id: z.string(),
    nombre: z.string(),
    prefijo: z.string(), // primeros caracteres visibles (ej. "a3k_AbC12…")
    rol: z.enum(ROLES),
    activa: z.boolean(),
    ultimoUsoEn: z.string().nullable(),
    creadoEn: z.string(),
    revocadaEn: z.string().nullable(),
    creadoPor: z.object({ id: z.string(), nombre: z.string(), email: z.string() }),
});
// Respuesta al crear: incluye la key COMPLETA en claro (única vez que se ve).
export const apiKeyCreadaSchema = z.object({
    apiKey: apiKeyPublicSchema,
    key: z.string(),
});
//# sourceMappingURL=apiKey.js.map